// removed by extract-text-webpack-plugin
module.exports = {"userPic":"_3fiQHoQZmkpgUZGn","my":"Fu08l5WtaCbs9yl6"};


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserPic.pcss
// module id = 515
// module chunks = 1